// Mobilde (≤640px) büyük veri tablolarını otomatik olarak "kart" görünümüne çevirir.
// Sadece görüntüleme katmanı: DOM'a data-label ve .cardify sınıfı ekler, veriye dokunmaz.

let scheduled = false;
let observer = null;

function processTables() {
  // 1) Uygun tabloları işaretle (thead + en az 2 başlık olan, dialog içinde olmayanlar)
  document.querySelectorAll("table.text-sm").forEach((tbl) => {
    if (tbl.classList.contains("cardify")) return;
    if (tbl.closest('[role="dialog"], [data-cardify-skip]')) return;
    const headRow = tbl.querySelector("thead tr");
    if (!headRow) return;
    const ths = headRow.querySelectorAll(":scope > th");
    if (ths.length < 2) return;
    tbl.classList.add("cardify");
  });

  // 2) Her kart hücresine başlık etiketini (data-label) yerleştir
  document.querySelectorAll("table.cardify").forEach((tbl) => {
    const headRow = tbl.querySelector("thead tr");
    if (!headRow) return;
    const ths = Array.from(headRow.querySelectorAll(":scope > th"));
    const labels = ths.map((th) =>
      (th.textContent || "").replace(/[↑↓⇅]/g, "").replace(/\s+/g, " ").trim()
    );
    tbl.querySelectorAll(":scope > tbody > tr").forEach((tr) => {
      const tds = Array.from(tr.querySelectorAll(":scope > td"));
      if (tds.length <= 1) return; // colspan / boş-durum satırları
      tds.forEach((td, i) => {
        const lbl = labels[i];
        if (lbl && td.getAttribute("data-label") !== lbl) {
          td.setAttribute("data-label", lbl);
        }
      });
    });
  });
}

function schedule() {
  if (scheduled) return;
  scheduled = true;
  requestAnimationFrame(() => {
    scheduled = false;
    try {
      processTables();
    } catch (e) {
      /* sessizce geç */
    }
  });
}

export function initCardify() {
  if (typeof document === "undefined") return () => {};
  schedule();
  if (!observer) {
    observer = new MutationObserver(() => schedule());
    observer.observe(document.body, { childList: true, subtree: true });
  }
  return () => {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
  };
}
